import { ParamListRoute } from '@react-navigation/native';
import config from 'config/config';
import { RootStackParamList } from 'types/navigation';
import { create } from 'zustand';

type AppConfigState = {
  navigateType: string | undefined;
  currentRoute: ParamListRoute<RootStackParamList> | undefined;
  bffUrl: string;
};

type AppConfigActions = {
  setNavigateType: (navigateType: string | undefined) => void;
  setCurrentRoute: (
    currentRoute: ParamListRoute<RootStackParamList> | undefined
  ) => void;
  setBffUrl: (bffUrl: string) => void;
};

export const useAppConfigStore = create<AppConfigState & AppConfigActions>()(
  (set) => ({
    navigateType: undefined,
    currentRoute: undefined,
    bffUrl: config.graphqlUrl,
    setNavigateType: (navigateType) => set({ navigateType }),
    setCurrentRoute: (currentRoute) => set({ currentRoute }),
    setBffUrl: (bffUrl) => set({ bffUrl }),
  })
);
